<script lang="ts">
  // Action toast (spec §16): i18n key or raw text, Undo while `undoToken` is set, timer held
  // while hovered or focused.
  import { hasKey, t } from '$lib/i18n';
  import { store } from '$lib/store';

  const text = $derived.by(() => {
    const k = store.toast;
    if (!k) return '';
    return hasKey(k) ? t(k) : k;
  });
</script>

{#if store.toast}
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div class="toast" role="group" onpointerenter={() => store.holdToast()} onpointerleave={() => store.releaseToast()} onfocusin={() => store.holdToast()} onfocusout={() => store.releaseToast()}>
    <output class="toast-msg">{text}</output>
    {#if store.undoToken}
      <button type="button" class="toast-act" data-undo onclick={() => void store.undo()}>{t('undo')}</button>
    {/if}
  </div>
{/if}

<style>
  /* @css shell/Toast start */
  .toast {
    position: fixed;
    inset-inline: 0;
    bottom: calc(var(--space-5) + env(safe-area-inset-bottom));
    margin-inline: auto;
    width: fit-content;
    max-width: calc(100% - var(--space-8));
    display: flex;
    align-items: center;
    gap: var(--space-3);
    background: var(--neutral-900);
    color: var(--neutral-0);
    padding: var(--space-3) var(--space-5);
    border-radius: var(--radius-pill);
    font-size: var(--text-sm);
    line-height: var(--leading-body);
    box-shadow: var(--shadow-lg);
    z-index: var(--z-toast);
    animation: svelte-1n46o8q-toast-in .2s var(--ease-out)
  }

  :global(html.tik-dark) .toast {
    background: var(--neutral-0);
    color: var(--neutral-900)
  }

  .toast-msg {
    min-width: 0
  }

  .toast-act {
    color: var(--blue-200);
    font-weight: var(--weight-semibold);
    padding: 4px 8px;
    border-radius: var(--radius-xs);
    flex: none
  }

  :global(html.tik-dark) .toast-act {
    color: var(--blue-700)
  }

  .toast-act:hover,
  .toast-act:active {
    background: #ffffff24
  }

  :global(html.tik-dark) .toast-act:hover,
  :global(html.tik-dark) .toast-act:active {
    background: #00000014
  }

  @media (max-width:900px) {
  .toast {
      bottom: calc(var(--tabbar-h) + var(--space-8) + env(safe-area-inset-bottom))
    }
  }

  @keyframes svelte-1n46o8q-toast-in {
    0% {
      opacity: 0;
      transform: translateY(8px)
    }
  }
  /* @css shell/Toast end */
</style>
